import {
  Button,
  Card,
  Col,
  Empty,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Spin,
  Table,
  notification,
} from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Breadcrumbs from "../../components/Breadcrumbs";
import api from "../../services/api";
import { FreireContext } from "../../utils/freireContext";
import * as texts from "./locales";
import "./index.css";

const { Option } = Select;

class CarCatalog extends Component {
  static contextType = FreireContext;

  state = {
    brands: [],
    loadingBrands: false,
    creatingBrand: false,
    loadingPlugs: false,
    plugs: [],
    modelModalVisible: false,
    creatingModel: false,
    selectedBrand: null,
  };

  componentDidMount() {
    this.fetchBrands();
    this.fetchPlugs();
  }

  fetchBrands = () => {
    const { freire } = this.context;

    this.setState({ loadingBrands: true }, async () => {
      try {
        const { data } = await api.get("brand");
        this.setState({ brands: data, loadingBrands: false });
      } catch (error) {
        notification.error({
          message: freire(texts.OOPS),
          description: freire(texts.ERROR_FETCH_BRANDS),
        });
        this.setState({ loadingBrands: false });
      }
    });
  };

  fetchPlugs = () => {
    const { freire } = this.context;

    this.setState({ loadingPlugs: true }, async () => {
      try {
        const { data } = await api.get("plugs");
        this.setState({ plugs: data, loadingPlugs: false });
      } catch (error) {
        notification.error({
          message: freire(texts.OOPS),
          description: freire(texts.ERROR_FETCH_PLUGS),
        });
        this.setState({ loadingPlugs: false });
      }
    });
  };

  handleCreateBrand = (event) => {
    event.preventDefault();
    const { form } = this.props;
    const { freire } = this.context;

    form.validateFields(["brandName"], (err, values) => {
      if (err) return;

      const payload = { name: values.brandName.trim() };

      this.setState({ creatingBrand: true }, async () => {
        try {
          await api.post("brand", payload);
          notification.success({
            message: freire(texts.ALL_RIGHT),
            description: freire(texts.BRAND_CREATED_SUCCESS),
          });
          form.resetFields(["brandName"]);
          this.fetchBrands();
        } catch (error) {
          notification.error({
            message: freire(texts.OOPS),
            description: freire(texts.ERROR_CREATE_BRAND),
          });
        } finally {
          this.setState({ creatingBrand: false });
        }
      });
    });
  };

  openModelModal = (brand) => {
    this.setState({ modelModalVisible: true, selectedBrand: brand });
  };

  closeModelModal = () => {
    if (this.modelFormRef) {
      this.modelFormRef.props.form.resetFields();
    }
    this.setState({
      modelModalVisible: false,
      creatingModel: false,
      selectedBrand: null,
    });
  };

  saveModelFormRef = (formRef) => {
    this.modelFormRef = formRef;
  };

  handleCreateModel = () => {
    if (!this.modelFormRef) return;

    const { freire } = this.context;
    const { selectedBrand } = this.state;

    if (!selectedBrand) return;
    const form = this.modelFormRef.props.form;

    form.validateFields((err, values) => {
      if (err) return;

      const payload = { ...values };

      if (payload.name) payload.name = payload.name.trim();
      if (payload.version) payload.version = payload.version.trim();

      const sanitizedPayload = Object.entries(payload).reduce((acc, [key, value]) => {
        if (value === undefined || value === null || value === "") return acc;
        acc[key] = value;
        return acc;
      }, {});

      this.setState({ creatingModel: true }, async () => {
        try {
          await api.post(`brand/${selectedBrand._id}/models`, sanitizedPayload);
          notification.success({
            message: freire(texts.ALL_RIGHT),
            description: freire(texts.MODEL_CREATED_SUCCESS),
          });
          this.closeModelModal();
          this.fetchBrands();
        } catch (error) {
          notification.error({
            message: freire(texts.OOPS),
            description: freire(texts.ERROR_CREATE_MODEL),
          });
          this.setState({ creatingModel: false });
        }
      });
    });
  };

  renderModelModal = () => {
    const { modelModalVisible, creatingModel, selectedBrand, plugs, loadingPlugs } =
      this.state;
    const { freire } = this.context;

    if (!selectedBrand) return null;

    return (
      <ModelForm
        wrappedComponentRef={this.saveModelFormRef}
        visible={modelModalVisible}
        confirmLoading={creatingModel}
        onCancel={this.closeModelModal}
        onCreate={this.handleCreateModel}
        freire={freire}
        plugs={plugs}
        loadingPlugs={loadingPlugs}
        brand={selectedBrand}
      />
    );
  };

  renderBrands = () => {
    const { brands, loadingBrands } = this.state;
    const { freire } = this.context;

    if (loadingBrands) {
      return (
        <div className="car-catalog__spinner">
          <Spin />
        </div>
      );
    }

    if (!brands.length) {
      return (
        <Empty description={freire(texts.NO_BRANDS)} className="car-catalog__empty" />
      );
    }

    return (
      <Row gutter={[16, 16]}>
        {brands.map((brand) => (
          <Col xs={24} lg={12} key={brand._id}>
            <Card
              title={brand.name}
              extra={
                <Button type="primary" onClick={() => this.openModelModal(brand)}>
                  {freire(texts.NEW_MODEL)}
                </Button>
              }
            >
              <ModelsTable models={brand.models || []} freire={freire} />
            </Card>
          </Col>
        ))}
      </Row>
    );
  };

  render() {
    const { freire } = this.context;
    const { creatingBrand } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <div className="container car-catalog">
        <Breadcrumbs
          breadcrumbs={[
            freire(texts.ADMIN),
            freire(texts.MANAGEMENT),
            freire(texts.CAR_CATALOG),
          ]}
        />

        <Card className="car-catalog__form-card">
          <Form layout="inline" onSubmit={this.handleCreateBrand}>
            <Form.Item>
              {getFieldDecorator("brandName", {
                rules: [
                  {
                    required: true,
                    message: freire(texts.REQUIRED_FIELD),
                  },
                ],
                getValueFromEvent: (event) => event.target.value.replace(/^\s+/, ""),
              })(
                <Input
                  placeholder={freire(texts.BRAND_PLACEHOLDER)}
                  maxLength={80}
                />
              )}
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={creatingBrand}>
                {freire(texts.ADD_BRAND)}
              </Button>
            </Form.Item>
          </Form>
        </Card>

        {this.renderBrands()}
        {this.renderModelModal()}
      </div>
    );
  }
}

class ModelFormInner extends Component {
  render() {
    const {
      visible,
      onCancel,
      onCreate,
      confirmLoading,
      freire,
      plugs,
      loadingPlugs,
      form,
      brand,
    } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Modal
        visible={visible}
        title={`${freire(texts.NEW_MODEL)} - ${brand.name}`}
        okText={freire(texts.SAVE)}
        cancelText={freire(texts.CANCEL)}
        onCancel={onCancel}
        onOk={onCreate}
        confirmLoading={confirmLoading}
      >
        <Form layout="vertical">
          <Form.Item label={freire(texts.NAME)}>
            {getFieldDecorator("name", {
              rules: [
                {
                  required: true,
                  message: freire(texts.REQUIRED_FIELD),
                },
              ],
            })(<Input maxLength={120} />)}
          </Form.Item>
          <Form.Item label={freire(texts.VERSION)}>
            {getFieldDecorator("version")(<Input maxLength={120} />)}
          </Form.Item>
          <Form.Item label={freire(texts.TYPE)}>
            {getFieldDecorator("type", {
              initialValue: "electric",
            })(
              <Select>
                <Option value="electric">{freire(texts.TYPE_ELECTRIC)}</Option>
                <Option value="hybrid">{freire(texts.TYPE_HYBRID)}</Option>
              </Select>
            )}
          </Form.Item>
          <Form.Item label={freire(texts.CAPACITY)}>
            {getFieldDecorator("capacity")(
              <InputNumber min={0} style={{ width: "100%" }} />
            )}
          </Form.Item>
          <Form.Item label={freire(texts.USABLE_CAPACITY)}>
            {getFieldDecorator("usableCapacity")(
              <InputNumber min={0} style={{ width: "100%" }} />
            )}
          </Form.Item>
          <Form.Item label={freire(texts.AC_POWER)}>
            {getFieldDecorator("ACPower")(
              <InputNumber min={0} style={{ width: "100%" }} />
            )}
          </Form.Item>
          <Form.Item label={freire(texts.DC_POWER)}>
            {getFieldDecorator("DCPower")(
              <InputNumber min={0} style={{ width: "100%" }} />
            )}
          </Form.Item>
          <Form.Item label={freire(texts.AUTONOMY)}>
            {getFieldDecorator("autonomy")(
              <InputNumber min={0} style={{ width: "100%" }} />
            )}
          </Form.Item>
          <Form.Item label={freire(texts.PLUGS)}>
            {getFieldDecorator("plugs")(
              <Select
                mode="multiple"
                placeholder={freire(texts.PLUGS_PLACEHOLDER)}
                loading={loadingPlugs}
              >
                {(plugs || []).map((plug) => (
                  <Option key={plug._id} value={plug.name}>
                    {plug.name}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

const ModelForm = Form.create({ name: "modelForm" })(ModelFormInner);

const ModelsTable = ({ models, freire }) => {
  if (!models.length) {
    return (
      <Empty
        description={freire(texts.NO_MODELS)}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  const columns = [
    {
      title: freire(texts.NAME),
      dataIndex: "name",
      key: "name",
    },
    {
      title: freire(texts.VERSION),
      dataIndex: "version",
      key: "version",
      render: (version) => version || "---",
    },
    {
      title: freire(texts.TYPE),
      dataIndex: "type",
      key: "type",
      render: (type) => type || "---",
    },
    {
      title: freire(texts.CAPACITY),
      dataIndex: "capacity",
      key: "capacity",
      render: (value) =>
        value === undefined || value === null ? "---" : value,
    },
    {
      title: freire(texts.PLUGS),
      dataIndex: "plugs",
      key: "plugs",
      render: (plugs) =>
        plugs && plugs.length ? plugs.join(", ") : "---",
    },
  ];

  return (
    <Table
      rowKey={(model) => model._id}
      dataSource={models}
      columns={columns}
      pagination={false}
      size="small"
    />
  );
};

const CarCatalogPage = Form.create({ name: "carCatalog" })(CarCatalog);
export default withRouter(CarCatalogPage);
